import './Articlelist.css';
import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"

const Articlelist = observer(
  class Articlelist extends Component {
    state={
      articles: false,
      searchkrit: ''
    }

		componentDidMount() {
			this.doSearch();
		}

		resetSearch = ()=>{
			this.setState({searchkrit: ''});
			setTimeout( this.doSearch(),1010);
		}

		doSearch = ()=>{
			let fields = [];
			if(this.state.searchkrit !== '') fields.push({ field: "_fulltext_", type: 'contains', value: this.state.searchkrit });
			fields.push({ field: "publishdate", type: 'ORDER', value: 'DESC' });
			// fields.push({ field: "eventcategory", type: '=', value: 'Unwetter' });
			//fields.push({ field: "members", type: 'FIND_IN_SET', value: this.props.userid });
			fields.push({ field: "workstatus", type: 'NOT REGEXP', value: '(;|^)'+this.props.userid+'(;|$)' });
			fields.push({ field: "workstatus", type: '!=', value: 'geschlossen' });
			// fields.push({ field: "", type: 'BEGIN_OR', value: '' });
			fields.push({ field: "members", type: 'REGEXP', value: '(;|^)'+this.props.userid+'(;|$)' });
			// fields.push({ field: "owner", type: '=', value: this.props.userid });
			// fields.push({ field: "", type: 'END_OR', value: '' });
			this.props.flow.cccmylog('Articelist -> cbDoSearch starte Suche ');			
			this.props.flow.getDistprojectsForDist('pmdb_newstv',0,fields,{'limit':20})
				.then(res=>this.cbDoSearch(res))
				.catch(e => {
					this.props.flow.cccmylog('Articelist -> cbDoSearch Suche fehlgeschlagen: ',e);			
					// this.props.flow.cccmylog(e);			
				});
		}
		
		cbDoSearch(res) {
			let erg = res.objects.asArray();
			this.props.flow.cccmylog('Articelist -> cbDoSearch ergebniscount: ' +  erg.length);			
			erg = erg.sort(function(a,b){return res.order.indexOf(a.id) > res.order.indexOf(b.id) ? 1 : -1});
			this.setState({articles:erg});
		}
		
    articleClicked = (id)=>{
			this.props.cbarticleclicked(id);
    }

    changeSearchkrit = (ev)=>{
			this.setState({searchkrit: ev.target.value});
    }


    render() {
      let results = false;
			if(this.state.articles) {
				results = this.state.articles.map(ar=>{
					return <Articlelistitem handleClick={this.articleClicked} cid={ar.getId()} key={ ar.getId() } article={ ar } />
				})
			}
			return  (
					<>
					<div className="artsearchrow">
						<input className="artsearchinp" type="text" value={ this.state.searchkrit } name="searchkrit" onChange={ this.changeSearchkrit } />
						<button className="artsearchresetknob" onClick={ this.resetSearch }>X</button>
						<button className="artsearchgoknob" onClick={ this.doSearch }>Suche</button>
					</div>
					<div className="articleheadline">Ihre offenen Artikel:</div>
					<div className="artlistcont"> {results} </div>
					</>
				);
    }
		
		
  }
)

function Articlelistitem(props) {
	let artid = props.article.getId();
	return <div onClick={()=>{ props.handleClick(artid) }} className="artlistitem">
					<div className="title">{ props.article.getMetadata().get('title')  + ' (' + props.article.getId() + ')'}</div>
				 </div>;
}

export default Flow.injectFlow(Articlelist);